<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <img
                      src="../assets/images/melake.jpg"
                      width="200"
                      height="200"
                      class="rounded-circle"
                    />
                  </a>
                </div>
              </div>
              <div
                class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center"
              >
                <div class="card-profile-actions py-4 mt-lg-0">
                  <a
                    href="https://drive.google.com/file/d/1Gaj-uI-dYnKwPj5bNJbNaLRZQgmfyP9H/view?usp=sharing"
                    target="_blank"
                  >
                    <base-button type="default" size="sm" class="mr-4"
                      >Get MY CV</base-button
                    >
                  </a>
                </div>
              </div>
              <div class="col-lg-4 order-lg-1">
                <div class="card-profile-stats d-flex justify-content-center">
                  <div>
                    <span class="heading">5+</span>
                    <span class="description">Experience</span>
                  </div>
                  <div>
                    <span class="heading">27</span>
                    <span class="description">Age</span>
                  </div>
                  <div>
                    <span class="heading">10+</span>
                    <span class="description">Projects</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-5">
              <h3>Melake Wubshet</h3>
              <div class="h6 font-weight-300">Software Engineer</div>
              <div class="h6 mt-4">Full-Stack Developer</div>
              <div>MEVN Stack + Vue js + Flutter</div>
            </div>
            <div class="mt-5 py-5 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <p>
                    As a full-stack developer and junior software architect, 
                    I've been working on designing and building enterprise apps, mobile apps, and Backend APIs. 
                    I have more than 6 years of experience in the field and have contributed a lot to the success of many projects. 
                    I am always eager to learn new things and I love working with others. I do have good analytical and problem-solving skills. 
                  </p>
                  <a href="#">Show more</a>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
    <!-- ********************* Experience ********************************** -->
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">Experience</h2>
            <p class="lead text-muted">
              My parctical experiences highlight my skills and passion.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 mt--150">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h6 class="text-warning text-uppercase">
                    CNET Software Technologies
                  </h6>
                  <p class="description mt-3">
                    Core programmer on Property Management System (PMS) and
                    other hospitality related ERP Systems. I was also working on
                    Smart Door lock integration, implementation and interfacing
                  </p>
                  <div>
                    <badge type="warning" rounded>.Net</badge>
                    <badge type="warning" rounded>c#</badge>
                    <badge type="warning" rounded>Interfacing</badge>
                    <badge type="warning" rounded>Full-Stack</badge>
                  </div>
                  <base-alert type="warning" class="mt-5"
                    >July 2016 - Feb 2019</base-alert
                  >
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h6 class="text-primary text-uppercase">
                    IBrave Technologies
                  </h6>
                  <p class="description mt-3">
                    I have been working on developing backend
                    api services and the frontend mobile app and web app. 
                  </p>
                  <div>
                    <badge type="primary" rounded>Vue Js</badge>
                    <badge type="primary" rounded>Software Architect</badge>
                    <badge type="primary" rounded>REST Api Developer</badge>
                    <badge type="primary" rounded>Flutter Developer</badge>
                    <badge type="primary" rounded>AWS</badge>
                    <badge type="primary" rounded>Agile</badge>
                    <badge type="primary" rounded>Leadership</badge>
                    <badge type="primary" rounded>Fullstack</badge>
                  </div>
                  <base-alert type="primary" class="mt-5"
                    >Feb 2019 - Nov 2021</base-alert
                  >
                </card>
              </div>
              <div class="col-lg-4 mb-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h6 class="text-success text-uppercase">
                    European Center for Electorial Support (ECES)
                  </h6>
                  <p class="description mt-3">
                    Backend Developer and Independent Contractor at UNDP Seed
                    Project to support the Ethiopian Election. I have been
                    working different projects such as Accreditation System,
                    NEBE Reporting Tools and Other Services to support the
                    Election Board.
                  </p>
                  <div>
                    <badge type="success" rounded>Backend Developer</badge>
                    <badge type="success" rounded>.Net Core</badge>
                    <badge type="success" rounded>C#</badge>
                  </div>
                  <base-alert type="success" class="mt-5"
                    >Jan 2021 - May 2021</base-alert
                  >
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h6 class="text-primary text-uppercase">Mobile App Engineer for Linkup App</h6>
                  <p class="description mt-3">
                    Building a brand new super app to Linkup Addis which comprises
                    Event Booking, Video Streaming, Podcast Streaming, Blog, and Digital 
                    Magazine. Check out the app at <a href="https://play.google.com/store/apps/details?id=com.ibrave.linkup"> Playstore</a>. 
                  </p>
                  <div>
                    <badge type="primary" rounded>Super App</badge>
                    <badge type="primary" rounded>Flutter</badge>
                    <badge type="primary" rounded>Dart</badge>
                    <badge type="primary" rounded>Mobile App Engineer</badge>
                  </div>
                  <base-alert type="primary" class="mt-5"
                    >Since June 2021</base-alert
                  >
                </card>
              </div>

              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h6 class="text-info text-uppercase">GDG Addis</h6>
                  <p class="description mt-3">
                    A lead community organizer at GDG Addis (Google Developers
                    Group). I've been leading this developer's community, with
                    more than 3000 members, since late 2017.
                  </p>
                  <div>
                    <badge type="info" rounded>community</badge>
                    <badge type="info" rounded>volunteer</badge>
                    <badge type="info" rounded>leadership</badge>
                  </div>
                  <base-alert type="info" class="mt-5"
                    >Dec 2017 - Jan 2021</base-alert
                  >
                </card>
              </div>

              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h6 class="text-black text-uppercase">Shoda</h6>
                  <p class="description mt-3">
                    Shoda is an apparel e-commerce platform that provides an amazing e-commerce 
                    experience. I have came up with the idea, designed and architected the backend 
                    service, built the mobile app client and managed the whole project.
                  </p>
                  <div>
                    <badge class="black" rounded>E-Commerce</badge>
                    <badge class="black" rounded>Full-Stack</badge>
                    <badge class="black" rounded>System Artchitect</badge>
                  </div>
                  <base-alert class="mt-5 black"
                    >Since May 2020</base-alert
                  >
                </card>
              </div>

              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h6 class="text-warning text-uppercase">
                    Personal Side Hustle Projects
                  </h6>
                  <p class="description mt-3">
                    Dagu Mobile App Developed with Flutter and Firebase. I have
                    also delivered the full-stacked sport betting platform
                    developed with Vue Js as well as .net core rest service
                    deployed on AWS.
                  </p>
                  <div>
                    <badge type="warning" rounded>Flutter</badge>
                    <badge type="warning" rounded>Firebase</badge>
                    <badge type="warning" rounded>Vue Js</badge>
                    <badge type="warning" rounded>.net Core</badge>
                  </div>
                  <base-alert type="warning" class="mt-5"
                    >Since 2016</base-alert
                  >
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ********************* Portfolios ********************************** -->
    <carousel></carousel>

    <!-- ********************* Contact Me ********************************** -->
    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg pb-200">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Get In Touch</h2>
            <p class="lead text-white">Don't hesitate to reach out to me</p>
          </div>
        </div>
        <div class="row justify-content-center row-grid mt-5">
          <div class="col-lg-4 text-center">
            <icon
              name="ni ni-email-83"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <p class="text-white mt-3">wubshetmelake@gmail.com</p>
          </div>
          <div class="col-lg-4 text-center">
            <icon
              name="ni ni-mobile-button"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <p class="text-white mt-3">+251-911434773 | +251-910896772</p>
          </div>
          <div class="col-lg-4 text-center">
            <icon
              name="ni ni-pin-3"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <p class="text-white mt-3">Addis Ababa, Ethiopia</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Carousel from "./components/Carousel";
export default {
  name: "components",
  components: {
    Carousel,
  },
};
</script>
<style>
</style>
